'use client'

import { EmptyState } from '@/components/ui'

/**
 * App-wide 404, rendered by `app/not-found.tsx`. It exists so Next's built-in 404 isn't used: that page injects
 * `body { background: #000 }` under `prefers-color-scheme: dark`, which turned the area around the sidebar black.
 */
export const NotFoundView = () => (
    <div className="flex min-h-[70dvh] items-center justify-center px-4" data-testid="not-found-page">
        <EmptyState
            title="Page not found"
            description="The page you’re looking for doesn’t exist or may have moved. Check the link, or head back to the home page."
            illustration={{ src: '/images/illustrations/folder-front-clay.png', alt: '', width: 120, height: 120 }}
            primaryButton={{ children: 'Go to home', href: '/', 'data-testid': 'not-found-page/home' }}
        />
    </div>
)
